import { render, staticRenderFns } from "./NfreshSubs.vue?vue&type=template&id=7224e9f2&scoped=true&"
import script from "./NfreshSubs.vue?vue&type=script&lang=ts&"
export * from "./NfreshSubs.vue?vue&type=script&lang=ts&"
import style0 from "./NfreshSubs.vue?vue&type=style&index=0&id=7224e9f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7224e9f2",
  null
  
)

export default component.exports